import { createStore } from '../_core/createStore';
import { analyticStore } from './analyticStore';
import { analytics } from './constants/analytics';

const useAnalyticStore = createStore({
  creator: analyticStore({
    analytics,
  }),
  id: 'analytic',
  middlewares: {
    devtools: true,
  },
});

export default useAnalyticStore;
